<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">

    <!-- Título -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Importar inventário por planilha</h1>
            <p class="welcome-message">
              <button mat-icon-button (click)="clickVoltar()">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Importe seus produtos rapidamente utilizando arquivos padronizados.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="action-card-grid">
      <a class="action-card-link" routerLink="/suprimentos/inventario/filtrar-produtos">
        <app-action-card
          icon="filter_list"
          title="Filtrar produtos"
          description="Precisa atualizar o estoque atual? Faça download do inventário base para importação."
          [interactive]="true">
        </app-action-card>
      </a>

      <button type="button" class="action-card-action" (click)="clickDownloadModelo()" [disabled]="_isDownloadingModelo">
        <app-action-card
          [icon]="_isDownloadingModelo ? '' : 'download'"
          title="Download planilha de exemplo"
          description="Baixe nosso modelo de arquivo CSV para garantir que os dados sejam validados."
          [interactive]="true"
          [disabled]="_isDownloadingModelo">
          @if (_isDownloadingModelo) {
            <mat-progress-spinner actionCardIcon diameter="20" mode="indeterminate"></mat-progress-spinner>
          }
        </app-action-card>
      </button>
    </div>

    <form [formGroup]="uploadForm">

      <!-- Zona de drop -->
      <div
        class="drop-zone"
        [class.drop-zone--active]="_isDragging"
        [class.drop-zone--file]="_arquivo"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
        (click)="fileInput.click()">
        <input #fileInput type="file" accept=".csv" hidden (change)="onFileSelected($event)" />
        @if (_arquivo) {
          <mat-icon class="drop-icon drop-icon--ok">check_circle</mat-icon>
          <p class="drop-title">{{ nomeArquivo() }}</p>
          <p class="drop-subtitle">{{ tamanhoArquivo() }} — clique para trocar</p>
        } @else {
          <mat-icon class="drop-icon">upload_file</mat-icon>
          <p class="drop-title">Clique para enviar ou arraste e solte</p>
          <p class="drop-subtitle">Formatos aceitos: CSV (Tamanho máximo: 2 MB)</p>
        }
      </div>

      <!-- Local destino -->
      <div class="section-label">Qual local deseja definir como padrão para a importação?</div>
      <mat-form-field appearance="outline" class="local-field">
        <mat-label>Local destino</mat-label>
        <mat-select formControlName="idLocalizacaoEstoque">
          @for (loc of _localizacoes; track loc.idLocalizacaoEstoque) {
            <mat-option [value]="loc.idLocalizacaoEstoque">{{ loc.nome }}</mat-option>
          }
        </mat-select>
        <mat-hint>Usado apenas quando o produto da planilha não informa local.</mat-hint>
      </mat-form-field>

      <!-- Modo de processamento -->
      <div class="section-label">Como deseja processar o inventário?</div>
      <mat-radio-group formControlName="modoProcessamento" class="radio-col">
        <mat-radio-button [value]="0">Atualizar apenas os produtos do arquivo de importação</mat-radio-button>
        <mat-radio-button [value]="1">Todos os produtos ativos no Sistema</mat-radio-button>
      </mat-radio-group>

      <app-alert-card type="warning">
        Caso opte por todos os produtos, o sistema vai ajustar a quantidade de todos os produtos com base na lista informada. Isso inclui tanto os produtos com diferença de estoque quanto os que ainda não foram conferidos.
      </app-alert-card>

    </form>

    <!-- Rodapé padrão -->
    <app-footer-action
      (salvar)="clickImportar()"
      [isLoadingSalvar]="_isValidating || _isProcessing"
      [isSalvarDisabled]="!_arquivo"
      [hideCancelar]="true"
      salvarLabel="Importar">
    </app-footer-action>

  </div>
</div>
